import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Button, Form } from 'react-bootstrap'
import { FiEdit, FiPlus, FiTrash2 } from 'react-icons/fi';
import toast from 'react-hot-toast'
import { deleteSubCategory, getSubCategoryListingPaginate, statusSubCatUpdate, vtoStatusSubCatUpdate } from '../../api/context/subcategory';
import CustomisedModal from '../../components/Modal/CustomisedModal';
import { IoMdArrowBack } from "react-icons/io";
import { IoSearchOutline } from 'react-icons/io5';
import { checkUserPermissions } from '../../helpers/permission';
import Loader from '../../components/loader/loader';
import { Switch, Tooltip } from '@mui/material';

const SubCategories = () => {
    const { state } = useLocation();
    const subcat = state?.data?.title;
    const { id } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [update, setUpdate] = useState(false);
    const [subcategory, setSubCategory] = useState([]);
    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");

    const [search, setSearch] = useState('');

    const PAGE_LIMIT = 1000;

    const user = JSON.parse(localStorage.getItem('user') || 'null');
    const isVendor = user?.userType === 'Vendor';
    const canManage = checkUserPermissions('manage_sub_category');

    const toggleModal = () => setModal(prev => !prev);

    const handleConfirm = (rowId) => {
        setDeletingId(rowId);
        setModal(true);
    };

    const statusActive = (rowId) => {
        const previous = [...subcategory];
        setSubCategory(prev =>
            prev.map(item =>
                item.id === rowId ? { ...item, isActive: !item.isActive } : item
            )
        );
        statusSubCatUpdate(rowId)((response) => {
            if (response?.data?.statusCode !== 200) {
                setSubCategory(previous);
                toast.error("Failed to update status");
            }
        });
    };

    const vtoStatusActive = (rowId) => {
        const previous = [...subcategory];
        setSubCategory(prev =>
            prev.map(item =>
                item.id === rowId ? { ...item, isAllowedForVTO: !item.isAllowedForVTO } : item
            )
        );
        vtoStatusSubCatUpdate(rowId)((response) => {
            if (response?.data?.statusCode !== 200) {
                setSubCategory(previous);
                toast.error("Failed to update VTO status");
            }
        });
    };

    const deleteSubCategories = (rowId) => {
        deleteSubCategory(rowId)((response) => {
            if (response?.data?.statusCode == 200) {
                toast.success("Sub Category removed");
                setModal(false);
                setUpdate(u => !u);
            } else {
                toast.error(response?.data?.message || "Failed to remove");
            }
        });
    };

    const getAllSubCategories = () => {
        setLoading(true);
        getSubCategoryListingPaginate({ id, page: 1, limit: PAGE_LIMIT })((response) => {
            if (response?.statusCode == 200) {
                setSubCategory(response?.data?.subSubCategory || []);
            } else {
                setSubCategory([]);
            }
            setLoading(false);
        });
    };

    useEffect(() => {
        getAllSubCategories();
    }, [update]);

    const filteredSubCategories = subcategory.filter((item) => {
        const q = search.trim().toLowerCase();
        if (!q) return true;
        return (item?.title || '').toLowerCase().includes(q);
    });


    return (
        <>
            <div className="subcategories-page">
                <style>{`
                    /* Fixed page header — always visible on desktop and mobile.
                       Padding matches the shared .page-header-sticky clamp() values so it looks
                       identical to other modernized pages (Categories, Dashboard, etc.). */
                    .subcategories-page .page-header-sticky {
                        position: fixed !important;
                        top: 0 !important;
                        left: var(--vz-vertical-menu-width, 208px) !important;
                        right: 0 !important;
                        z-index: 1030 !important;
                        background: #f9fafb !important;
                        border-bottom: 1px solid #e2e8f0 !important;
                        margin: 0 !important;
                        padding: clamp(20px, 2.5vw, 40px) clamp(20px, 3vw, 48px) clamp(16px, 2vw, 32px) !important;
                    }
                    /* Content padding to clear the fixed header on desktop */
                    .subcategories-page { padding-top: 112px; }

                    @media (max-width: 1399.98px) {
                        .subcategories-page { padding-top: 104px; }
                    }
                    @media (max-width: 1199.98px) {
                        .subcategories-page { padding-top: 96px; }
                    }
                    @media (max-width: 991px) {
                        .subcategories-page .page-header-sticky {
                            padding: 24px 20px 20px !important;
                        }
                        .subcategories-page { padding-top: 82px; }
                    }
                    @media (max-width: 767.98px) {
                        .subcategories-page .page-header-sticky {
                            left: 0 !important;
                            padding: 14px 16px 12px !important;
                        }
                        .subcategories-page { padding-top: 58px; }
                    }
                    @media (max-width: 575.98px) {
                        .subcategories-page .page-header-sticky {
                            padding: 12px 14px 10px !important;
                        }
                        .subcategories-page { padding-top: 52px; }
                    }

                    /* Header */
                    .subcategories-page .page-header-sticky h3 { font-size: 18px !important; font-weight: 700 !important; color: #0f172a !important; letter-spacing: -0.01em !important; margin: 0 !important; }

                    /* Add button (desktop) */
                    .subcategories-page .request_btn {
                        background: #008695 !important;
                        border: 1px solid #008695 !important;
                        color: #fff !important;
                        font-weight: 600 !important;
                        padding: 6px 14px !important;
                        border-radius: 4px !important;
                        font-size: 12px !important;
                        height: 34px !important;
                        display: inline-flex !important;
                        align-items: center !important;
                        gap: 6px !important;
                        white-space: nowrap;
                        box-shadow: none !important;
                    }
                    .subcategories-page .request_btn:hover,
                    .subcategories-page .request_btn:focus,
                    .subcategories-page .request_btn:active {
                        background: #006672 !important;
                        border-color: #006672 !important;
                        color: #fff !important;
                    }

                    /* Search row (outside header) — full width, no extra top gap */
                    .subcategories-page .subcat-search-row {
                        margin: 0 0 12px !important;
                        max-width: 100%;
                    }
                    .subcategories-page .subcat-search-row .subcat-search { width: 100% !important; }

                    /* Search input */
                    .subcategories-page .subcat-search {
                        border: 1px solid #e2e8f0 !important;
                        border-radius: 4px !important;
                        padding: 6px 12px !important;
                        font-size: 12px !important;
                        min-height: 34px !important;
                        height: 34px !important;
                        background: #fff !important;
                        color: #0f172a !important;
                    }
                    .subcategories-page .subcat-search:focus {
                        border-color: #008695 !important;
                        box-shadow: 0 0 0 3px rgba(0,134,149,0.15) !important;
                        outline: none !important;
                    }

                    /* Back button */
                    .subcategories-page .back-btn {
                        display: inline-flex; align-items: center; justify-content: center;
                        width: 30px; height: 30px; border-radius: 4px;
                        border: 1px solid #e2e8f0; background: #fff;
                        color: #475569; cursor: pointer; padding: 0;
                        transition: all 0.15s ease;
                    }
                    .subcategories-page .back-btn:hover { border-color: #cbd5e1; background: #f8fafc; }

                    /* Admin card grid — min 5 columns on desktop, min 2 on mobile */
                    .subcategories-page .subcategories-admin-grid {
                        display: grid;
                        grid-template-columns: repeat(5, minmax(0, 1fr));
                        gap: 14px;
                        padding: 4px 0 24px;
                    }
                    @media (max-width: 1399.98px) {
                        .subcategories-page .subcategories-admin-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; }
                    }
                    @media (max-width: 1199.98px) {
                        .subcategories-page .subcategories-admin-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); }
                    }
                    @media (max-width: 767.98px) {
                        .subcategories-page .subcategories-admin-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
                    }

                    /* Admin card */
                    .subcategories-page .subcat-admin-card {
                        background: #fff;
                        border: 1px solid #e2e8f0;
                        border-radius: 8px;
                        box-shadow: 0 1px 2px rgba(15,23,42,0.04);
                        overflow: hidden;
                        display: flex;
                        flex-direction: column;
                        transition: transform 0.15s ease, box-shadow 0.2s ease, border-color 0.15s ease;
                    }
                    .subcategories-page .subcat-admin-card:hover {
                        border-color: #008695;
                        box-shadow: 0 6px 18px -10px rgba(15,23,42,0.14);
                        transform: translateY(-2px);
                    }
                    .subcategories-page .admin-card-media {
                        position: relative;
                        aspect-ratio: 4 / 3;
                        background: #f8fafc;
                        overflow: hidden;
                    }
                    .subcategories-page .admin-card-media img { width: 100%; height: 100%; object-fit: cover; display: block; }
                    .subcategories-page .admin-card-media .no-image {
                        width: 100%; height: 100%;
                        display: flex; align-items: center; justify-content: center;
                        color: #94a3b8; font-size: 10px;
                    }
                    .subcategories-page .admin-card-actions {
                        position: absolute;
                        top: 6px; right: 6px;
                        display: flex; gap: 4px;
                    }
                    .subcategories-page .card-icon-btn {
                        display: inline-flex; align-items: center; justify-content: center;
                        width: 26px; height: 26px;
                        border-radius: 4px;
                        border: 0;
                        cursor: pointer;
                        transition: all 0.15s ease;
                        padding: 0;
                    }
                    .subcategories-page .card-edit-btn {
                        background: rgba(255,255,255,0.95);
                        color: #008695;
                        box-shadow: 0 1px 4px rgba(15,23,42,0.15);
                    }
                    .subcategories-page .card-edit-btn:hover { background: #f0fdfa; }
                    .subcategories-page .card-delete-btn {
                        background: rgba(255,255,255,0.95);
                        color: #dc2626;
                        box-shadow: 0 1px 4px rgba(15,23,42,0.15);
                    }
                    .subcategories-page .card-delete-btn:hover { background: #fef2f2; }

                    .subcategories-page .admin-card-body {
                        padding: 10px 12px 12px;
                    }
                    .subcategories-page .admin-card-title-row {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        gap: 8px;
                        min-width: 0;
                    }
                    .subcategories-page .admin-card-title {
                        font-size: 13px; font-weight: 600; color: #0f172a;
                        margin: 0; line-height: 1.3; letter-spacing: -0.01em;
                        white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                        flex: 1; min-width: 0;
                    }
                    .subcategories-page .admin-card-title-row .MuiSwitch-root {
                        transform: scale(0.8);
                        margin: -6px -8px -6px 0;
                        flex-shrink: 0;
                    }

                    .subcategories-page .admin-empty {
                        grid-column: 1 / -1;
                        padding: 40px 16px; text-align: center;
                        font-size: 12px; color: #94a3b8;
                        background: #f8fafc; border: 1px dashed #cbd5e1; border-radius: 8px;
                    }

                    @media (max-width: 575.98px) {
                        .subcategories-page .admin-card-title { font-size: 12px; }
                        .subcategories-page .admin-card-body { padding: 8px 10px 10px; }
                    }

                    /* Vendor grid: 5/4/3/3 for vendor (3 in a row on mobile) */
                    .subcategories-page .subcategories-vendor-grid {
                        display: grid !important;
                        grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
                        gap: 14px !important;
                    }
                    @media (max-width: 1399.98px) {
                        .subcategories-page .subcategories-vendor-grid { grid-template-columns: repeat(4, minmax(0, 1fr)) !important; gap: 12px !important; }
                    }
                    @media (max-width: 1199.98px) {
                        .subcategories-page .subcategories-vendor-grid { grid-template-columns: repeat(3, minmax(0, 1fr)) !important; }
                    }
                    @media (max-width: 767.98px) {
                        .subcategories-page .subcategories-vendor-grid { grid-template-columns: repeat(3, minmax(0, 1fr)) !important; gap: 8px !important; }
                    }

                    /* Vendor card compact styling */
                    .subcategories-page .subcat-card {
                        aspect-ratio: 3 / 4 !important;
                        border-radius: 8px !important;
                        box-shadow: 0 1px 4px rgba(15,23,42,0.06) !important;
                    }
                    .subcategories-page .subcat-card .no-image { font-size: 10px !important; color: #94a3b8 !important; }
                    .subcategories-page .subcat-card .title-overlay { padding: 40px 10px 10px !important; }
                    .subcategories-page .subcat-card .title-overlay h3 { font-size: 12px !important; font-weight: 600 !important; text-shadow: 0 1px 3px rgba(0,0,0,0.5) !important; }
                    @media (max-width: 767.98px) {
                        .subcategories-page .subcat-card { border-radius: 6px !important; }
                        .subcategories-page .subcat-card .title-overlay { padding: 32px 6px 8px !important; }
                        .subcategories-page .subcat-card .title-overlay h3 { font-size: 10px !important; line-height: 1.2 !important; }
                        .subcategories-page .subcat-card .no-image { font-size: 9px !important; }
                    }

                    .subcategories-page .subcat-empty {
                        font-size: 12px !important;
                        color: #94a3b8 !important;
                        background: #f8fafc !important;
                        border: 1px dashed #cbd5e1 !important;
                        border-radius: 8px !important;
                        padding: 40px 16px !important;
                    }

                    /* Mobile fixed submit bar (hidden by default) */
                    .subcategories-page .mobile-add-bar { display: none; }

                    @media (max-width: 767.98px) {
                        .subcategories-page .page-header-sticky .request_btn { display: none !important; }
                        .subcategories-page { padding-bottom: 68px !important; }
                        .subcategories-page .mobile-add-bar {
                            display: flex !important;
                            align-items: center;
                            justify-content: center;
                            position: fixed;
                            left: 0; right: 0; bottom: 0;
                            padding: 10px 14px calc(10px + env(safe-area-inset-bottom, 0px));
                            background: #fff;
                            border-top: 1px solid #e2e8f0;
                            box-shadow: 0 -4px 12px rgba(15,23,42,0.06);
                            z-index: 1049;
                        }
                        .subcategories-page .mobile-add-bar .request_btn {
                            width: 100% !important;
                            height: 40px !important;
                            justify-content: center;
                            font-size: 13px !important;
                            padding: 8px 16px !important;
                        }
                    }
                    @media (max-width: 575.98px) {
                        .subcategories-page .page-header-sticky h3 { font-size: 16px !important; }
                    }
                `}</style>

                <div className="page-header-sticky">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
                        <div className="d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
                            <button
                                type="button"
                                onClick={() => navigate('/categories')}
                                className="back-btn"
                                aria-label="Back to categories"
                            >
                                <IoMdArrowBack style={{ fontSize: 16 }} />
                            </button>
                            <h3 className="fw-bold">
                                {isVendor
                                    ? (subcat ? `${subcat} Collection` : 'Sub Categories')
                                    : (subcat ? `${subcat} Sub Categories` : 'Sub Categories')}
                            </h3>
                        </div>

                        {canManage && !isVendor && (
                            <Button
                                className="request_btn"
                                onClick={() => navigate(`/create-sub-categories`, {
                                    state: {
                                        categoryId: id,
                                        categoryName: subcat,
                                    }
                                })}
                            >
                                <FiPlus size={14} strokeWidth={2.5} />
                                Add New SubCategory
                            </Button>
                        )}
                    </div>
                </div>

                {/* Search bar outside sticky header */}
                <div className="subcat-search-row">
                    <Form.Control
                        type="text"
                        className="subcat-search"
                        placeholder="Search sub categories..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                {isVendor ? (
                            loading ? (
                                <div style={{ minHeight: '60vh' }}><Loader /></div>
                            ) : (
                                <div className="subcategories-vendor-grid">
                                    {filteredSubCategories.length > 0 ? (
                                        filteredSubCategories.map((row) => (
                                            <div className="subcat-card" key={row?.id}>
                                                {row?.img ? (
                                                    <img src={row.img} alt={row?.title} />
                                                ) : (
                                                    <div className="no-image">No image</div>
                                                )}
                                                <div className="title-overlay">
                                                    <h3>{row?.title}</h3>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="subcat-empty">No Sub Categories Found</div>
                                    )}
                                </div>
                            )
                        ) : (
                            loading ? (
                                <div style={{ minHeight: '50vh' }}><Loader /></div>
                            ) : (
                                <div className="subcategories-admin-grid">
                                    {filteredSubCategories.length > 0 ? (
                                        filteredSubCategories.map((row) => (
                                            <div className="subcat-admin-card" key={row?.id}>
                                                <div className="admin-card-media">
                                                    {row?.img ? (
                                                        <img src={row.img} alt={row?.title} />
                                                    ) : (
                                                        <div className="no-image">No image</div>
                                                    )}
                                                    {canManage && (
                                                        <div className="admin-card-actions">
                                                            <Tooltip title="Edit" disableInteractive placement="top">
                                                                <button
                                                                    type="button"
                                                                    className="card-icon-btn card-edit-btn"
                                                                    onClick={() => navigate(`/create-sub-categories/${row.id}`, { state: { subCategoryData: row } })}
                                                                >
                                                                    <FiEdit size={13} />
                                                                </button>
                                                            </Tooltip>
                                                            <Tooltip title="Delete" disableInteractive placement="top">
                                                                <button
                                                                    type="button"
                                                                    className="card-icon-btn card-delete-btn"
                                                                    onClick={(e) => { e.stopPropagation(); handleConfirm(row?.id); }}
                                                                >
                                                                    <FiTrash2 size={13} />
                                                                </button>
                                                            </Tooltip>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="admin-card-body">
                                                    <div className="admin-card-title-row">
                                                        <Tooltip title={row?.title || ''} disableInteractive placement="top">
                                                            <h3 className="admin-card-title">{row?.title}</h3>
                                                        </Tooltip>
                                                        {canManage && (
                                                            <Switch
                                                                size="small"
                                                                checked={!!row?.isActive}
                                                                onChange={() => statusActive(row?.id)}
                                                                className="custom-switch"
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="admin-empty">No Sub Categories Found</div>
                                    )}
                                </div>
                            )
                        )}

                <CustomisedModal
                    isOpen={modal}
                    customClass={"policy_modal"}
                    toggle={toggleModal}
                >
                    <h5>Are you sure you want to remove this item?</h5>
                    <div className="policy_Agree">
                        <Button
                            onClick={() => setModal(false)}
                            size="lg"
                            className="btn_cancel"
                        >
                            Cancel
                        </Button>
                        <Button
                            size="lg"
                            className="btn"
                            onClick={() => deleteSubCategories(deletingId)}
                        >
                            Remove
                        </Button>
                    </div>
                </CustomisedModal>

                {/* Mobile-only fixed Add New SubCategory button */}
                {canManage && !isVendor && (
                    <div className="mobile-add-bar">
                        <Button
                            className="request_btn"
                            onClick={() => navigate(`/create-sub-categories`, {
                                state: { categoryId: id, categoryName: subcat }
                            })}
                        >
                            <FiPlus size={14} strokeWidth={2.5} />
                            Add New SubCategory
                        </Button>
                    </div>
                )}
            </div>
        </>
    );
};

export default SubCategories;
